var WebSettings = {
  //实时监控刷新时间（ms）
  refreshTime: 10000,
  //是否为国内服务器,常用与是否纠偏
  SERVER_EXISTIN_CHINA: true,
  getSettings: function () {
    // 这里定义了一个函数来获取 WebSettings 的所有设置
    return {}
  },
}

export default WebSettings
